/**
 * Validates if a field is not empty.
 * @param {string} value - The value of the input field.
 * @returns {boolean} - Returns true if valid, false otherwise.
 */
export const isNotEmpty = (value) => {
    return value.trim() !== '';
};
/**
 * Validates if a value is a valid number.
 * @param {string} value - The value of the input field.
 * @returns {boolean} - Returns true if valid, false otherwise.
 */
export const isValidNumber = (value) => {
    const numberRegex=/^[0-9]+$/;
    return value.trim() === '' || numberRegex.test(value);
};

/**
 * Validates if a value graterthen a specific length.
 * @param {string} value - The value of the input field.
 * @param {number} length - The required length.
 * @returns {boolean} - Returns true if valid, false otherwise.
 */
export const hasGraterthenLength = (value, length) => {
    return value.trim().length > length;
};

/**
 * Validates if a value matches a specific length.
 * @param {string} value - The value of the input field.
 * @param {number} length - The required length.
 * @returns {boolean} - Returns true if valid, false otherwise.
 */
export const hasSpecificLength = (value, length) => {
    return value.trim().length === length;
};

/**
 * Validates if a value is a valid mobile number.
 * @param {string} value - The value of the input field.
 * @returns {boolean} - Returns true if valid, false otherwise.
 */
export const isValidMobileNumber = (value) => {
    const mobileRegex = /^[6-9]+[0-9]{0,9}$/i;
    return mobileRegex.test(value)
};

/**
 * Validates if a value is a valid email.
 * @param {string} value - The value of the input field.
 * @returns {boolean} - Returns true if valid, false otherwise.
 */
export const isValidEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
};

/**
 * Validates if a select option is selected.
 * @param {string} value - The value of the selected option.
 * @returns {boolean} - Returns true if an option is selected, false otherwise.
 */
export const isOptionSelected = (value) => {
    return value !== null && value !== undefined && value.trim() !== '';
};
export const isStartedWithNumber = (value) => {
    const startsWithNumberRegex = /^[0-9]/;
    return startsWithNumberRegex.test(value);
};
export const hasSpecialCharacter = (value) => {
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/g;
    return specialCharRegex.test(value);
};
